module.exports = __webpack_public_path__ + "static/media/ogi.6578934c.jpg";